const modalPagesUris = [`talk-to-us-lightbox`]

function validator(path) {
  return modalPagesUris.map(u => `/${u}/`).includes(path)
}

module.exports.modalsPathValidator = {
  pageUris: modalPagesUris,
  validator: validator,
}
